import { useState } from "react";
import { BUSINESS_INSURANCE } from "./paths";
import { trackPageView, trackPageViewByPageName } from "utils/analytics";

const useRouterPreNavigationMiddleware = () => {
  const [openInsuranceDialog, setOpenInsuranceDialog] = useState(false); //for Business insurance page Dialog Box pre navigation

  const handleBusinesInsurancePreNavigation = (action) => {
    if (location.pathname === BUSINESS_INSURANCE) {
      //if the current location is already on  business insurance page,
      //prevent the insurance dialog from popping up.
      //Just scroll the window to top instead

      setOpenInsuranceDialog(false);

      return action !== "REPLACE";
    }

    if (!openInsuranceDialog) {
      setOpenInsuranceDialog(true);

      return false;
    }

    return true; //default
  };

  const handleRoutes = (next, action) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // try {
    //   trackPageViewByPageName(next.pathname);
    // } catch (e) {}
    switch (next.pathname) {
      case BUSINESS_INSURANCE: {
        return handleBusinesInsurancePreNavigation(action);
      }
      default: {
        return true;
      }
    }
  };

  const closeInsuranceDialog = () => {
    setOpenInsuranceDialog(false);
  };

  return {
    openInsuranceDialog,
    closeInsuranceDialog,
    handleRoutes,
  };
};

export default useRouterPreNavigationMiddleware;
